module.exports = __webpack_public_path__ + "img/sub.7dd54291.png";